/** Максимальная ширина телефона */
export const RESPONSIVE_BREAKPOINT_PHONE_MAX = 640;
/** Минимальная ширина планшета */
export const RESPONSIVE_BREAKPOINT_TABLET_MIN = RESPONSIVE_BREAKPOINT_PHONE_MAX + 1;
/** Максимальная ширина планшета */
export const RESPONSIVE_BREAKPOINT_TABLET_MAX = 1024;
/** Минимальная ширина десктопа */
export const RESPONSIVE_BREAKPOINT_DESKTOP_MIN = RESPONSIVE_BREAKPOINT_TABLET_MAX + 1;

/** Строка для передачи в matchMedia для определения телефона */
export const RESPONSIVE_MEDIA_QUERY_PHONE = "(max-width: ".concat(RESPONSIVE_BREAKPOINT_PHONE_MAX, "px)");
/** Строка для передачи в matchMedia для определения планшета */
export const RESPONSIVE_MEDIA_QUERY_TABLET = "(min-width: ".concat(RESPONSIVE_BREAKPOINT_TABLET_MIN, "px) and (max-width: ").concat(RESPONSIVE_BREAKPOINT_TABLET_MAX, "px)");
/** Строка для передачи в matchMedia для определения десктопа */
export const RESPONSIVE_MEDIA_QUERY_DESKTOP = "(min-width: ".concat(RESPONSIVE_BREAKPOINT_DESKTOP_MIN, "px)");